export const titleFonts: Fonts = {
  fontFamilly: "Arial, Helvetica, sans-serif",
  fontSize: "38px",
  fontWeight: "bold",
};

export const subTitleFonts: Fonts = {
  fontFamilly: "Arial, Helvetica, sans-serif",
  fontSize: "20px",
  fontWeight: "normal",
};

export const primaryFonts: Fonts = {
  fontFamilly: "Arial, Helvetica",
  fontSize: "20px",
  fontWeight: "normal",
};

export const secondaryFonts: Fonts = {
  fontFamilly: "String",
  fontSize: "18px",
  fontWeight: "String",
};
